import request from './request';

const TIME_OUT = 8000;
export default class Task {
  constructor(params) {
    this.query = params.query;
    this.timeout = params.timeout || TIME_OUT;
    this.requestURL = params.requestURL;
    this.requestHeader = params.requestHeader;
    this.requestMethod = params.requestMethod || 'POST';
    this.withCredentials = params.withCredentials;
  }

  sendRequest(successHandler, errorHandler) {
    let reqMethod = this.requestMethod;
    let reqUrl = this.requestURL;
    let reqHeader = this.requestHeader;
    let query = this.query;
    let timeout = this.timeout;

    console.log('请求头：', reqHeader);
    console.log('请求地址：' + reqUrl);
    console.log('请求参数', query);

    let options = {
      method: reqMethod,
      url: reqUrl, 
      timeout: timeout, 
      data: query, 
      header: reqHeader, 
      withCredentials: this.withCredentials
    }
    request(options)
      .then((res) => {
        let fcgiRet = null;
        let trpcRet = null;
        let statusCode = res.statusCode;
        fcgiRet = res.header['Fcgi-Ret'] || res.header['fcgi-ret'];
        trpcRet = res.header['Trpc-Ret'] || res.header['trpc-ret'];
        console.log(res);
        if (statusCode === 200 && !fcgiRet && !trpcRet) {
          if (successHandler) {
            console.log('successHandler');
            successHandler(res);
          }
        } else {
          if (errorHandler) {
            console.log('errorHandler');
            errorHandler(res);
          }
        }
      })
      .catch((res) => {
        console.log('返回值失败：');
        console.log(res);

        if (errorHandler) {
          console.log('返回值失败：', 'errorHandler');
          errorHandler(res);
        }
      });
  }
}
